module.exports = __webpack_public_path__ + "img/hk_lv2.b93bc591.webp";